/**
 * Ported from production `replacement-filters.js` as `replacement-filters-prev.js`.
 * Registers `collection-filters-replacement-parts-prev`. Replacement-parts UI is mostly HTMX + jQuery Flickity in the section;
 * this element exists so the tag is upgraded; stubs avoid errors if legacy handlers call into it.
 */
(function () {
  if (customElements.get('collection-filters-replacement-parts-prev')) return;

  function debounce(fn, delay) {
    let timer = null;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  function onKeyUpEscape(event) {
    if (event.code !== 'Escape') return;
    const openDetails = event.target.closest('details[open]');
    if (openDetails) openDetails.removeAttribute('open');
  }

  class CollectionFiltersReplacementPartsPrev extends HTMLElement {
    constructor() {
      super();
      this.filterData = [];
      this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 500);

      this.addEventListener('change', this.debouncedOnSubmit);

      this.querySelectorAll('.collection-filter__button-wrapper').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          const input = button.querySelector('input[type="radio"]');
          if (input) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });

      window.addEventListener('popstate', this.onHistoryChange.bind(this));

      const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
      if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
    }

    onSubmitHandler(event) {
      event.preventDefault();

      const formData = new URLSearchParams();
      this.querySelectorAll('input[name="filter"]').forEach((input) => {
        if (input.checked) {
          formData.append(input.name, input.value);
        }
      });
      const searchParams = formData.toString();

      this.renderPage(searchParams, event);
    }

    onHistoryChange(event) {
      const searchParams = event.state ? event.state.searchParams : '';
      this.renderPage(searchParams, null, false);
    }

    onActiveFilterClick(event) {
      event.preventDefault();
      this.toggleActiveFacets();
      this.renderPage(new URL(event.currentTarget.href).searchParams.toString());
    }

    toggleActiveFacets(_disable = true) {}

    renderPage(_searchParams, _event, _updateURLHash = true) {}
  }

  customElements.define('collection-filters-replacement-parts-prev', CollectionFiltersReplacementPartsPrev);
})();
